export const environment = {
  properties: {
    analytics: {
      tagManagerContainerId: 'GTM-PZNCSJK',
    },
    app: {
      environmentLabel: 'Development',
      featureFlags: {},
    },
    cdn: {
      baseUrl: 'https://static.apps.psu.edu/',
    },
    collegeCostEstimator: {
      url: 'https://develop-college-cost-estimates.qa.k8s.psu.edu/college-cost-web/resources/',
    },
    fortress: {
      activatedRoles: ['COLLEGE.COST.ESTIMATES.OPERATOR'],
      url: 'https://develop-fortress-service.qa.k8s.psu.edu/fortress-service-web/resources/',
    },
    oauth: {
      clientId: '512e8ce5-8852-4a8d-a91d-a2b1d1efa4f3',
      discoveryDocumentUrl: 'https://develop-hydra-auth-server.qa.k8s.psu.edu/.well-known/openid-configuration',
      issuer: 'https://develop-oauth2-server.qa.k8s.psu.edu/',
      preserveRequestedRoute: true,
      redirectUri: 'https://collegecostadmin.development.apps.psu.edu',
      responseType: 'code',
      scope: 'openid offline_access',
      showDebugInformation: true,
      strictDiscoveryDocumentValidation: false,
    },
  },
};
